import React from 'react';
import { businessTripFolderSettiongs, businessTripFileTypes } from '../../constants.js';
import FileSelect from './FileSelect.js';
import i18next from '../../i18n.js';

const DocumentSelectForm = (props) => {
    const getFileFolders = () => {
        let result = [];
        if (props.value?.children?.length > 0) {
            result = props.value.children.filter(child => child.hasChildren ||
                (
                    !props.disabled &&
                    businessTripFolderSettiongs.find(s => s.title === child.title)?.fileTypes?.some(t => props.fileTypes?.includes(t))
                ) ||
                (
                    businessTripFolderSettiongs.find(s => s.title === child.title)?.fileTypes?.some(t => props.fileTypes?.includes(t)) &&
                    businessTripFolderSettiongs.find(s => s.title === child.title)?.required
                )
            );
        }
        result.forEach(item => {
            const folderSettings = businessTripFolderSettiongs.find(s => s.title === item.title);
            if (folderSettings) {
                item.description = folderSettings.description;
                if (folderSettings.title === '04. Транспортні документи') {
                    const docNames = [];
                    if (props.fileTypes) {
                        if (props.fileTypes.includes(businessTripFileTypes.registrationCertificate)) {
                            docNames.push(i18next.t('document.businessTripFileTypes.registrationCertificate'));
                        }
                        if (props.fileTypes.includes(businessTripFileTypes.paymentInvoice)) {
                            docNames.push(i18next.t('document.businessTripFileTypes.paymentInvoice'));
                        }
                        if (props.fileTypes.includes(businessTripFileTypes.leaseDeed)) {
                            docNames.push(i18next.t('document.businessTripFileTypes.leaseDeed'));
                        }
                    }
                    item.description = docNames.length > 0 ? item.description.replace('{0}', docNames.join(', ')) : '';
                }
            }
        });
        return result;
    }

    const onFileChanged = (e) => {
        if (props.onChange) {
            let newValue = structuredClone(props.value);
            const folder = newValue.children.find(child => child.title === e.target.name);
            if (folder.folderContent?.children) {
                folder.folderContent.children = e.target.value;
            }
            else {
                folder.folderContent = {
                    children: e.target.value
                }
            }
            folder.hasChildren = folder.folderContent.children?.length > 0;
            props.onChange({
                target: {
                    name: props.name,
                    value: newValue
                }
            });
        }
    }

    const fileFolders = getFileFolders();

    return (<div className="document-select">
        {fileFolders.length > 0 && fileFolders.map((item, index) => <FileSelect key={index} {...item} disabled={props.disabled} onChange={(e) => onFileChanged(e, item.title)} />)}
        {fileFolders.length === 0 && <span className='not-added-label'>{i18next.t('other.notNeedAddDocuments')}</span>}
    </div>);
}
export default DocumentSelectForm;